import { call, delay, put, takeLatest } from "redux-saga/effects";

import { startLoader, stopLoader } from "../../../../utils/commonFunctions";

import { toast } from "react-toastify";

import { VendorPincodeActionTypes, VendorPincodeActions } from "../../../actionTypes/master/vendorPincodeActionTypes";

import { getVendorPincodeListApi } from "../../requests/master/vendorPincodeRequests";
import { setVendorPincodeList, setVendorPincodeListPageCount } from "../../../actions/master/vendorPincodeActions";


function* getVendorPincodeListHandler(action: VendorPincodeActionTypes) {
  yield delay(500);
  try {
    yield startLoader("transparent");

    const { data } = yield call(getVendorPincodeListApi, action.payload);

    const rows = data?.data?.rows;
    if (data?.status && Array.isArray(rows)) {
      yield put(setVendorPincodeList(rows));
      yield put(setVendorPincodeListPageCount(data?.data?.count ?? 0));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message ?? "Failed to load vendor pincodes", {
      position: "top-right",
    });
  } finally {
    yield stopLoader("transparent");
  }
}

export default function* vendorPincodeSaga() {
  yield takeLatest(VendorPincodeActions.GET_VENDOR_PINCODE_LIST, getVendorPincodeListHandler);
}
